import { BehaviorSubject } from "rxjs";
import * as i0 from "@angular/core";
import * as i1 from "./license.proxy";
var LicenseService = /** @class */ (function () {
    function LicenseService(licenseProxy) {
        var _this = this;
        this.licenseProxy = licenseProxy;
        this.licenseValidated = new BehaviorSubject(undefined);
        this.validateLicense().subscribe(function (res) {
            _this.licenseValidated.next(res);
        });
    }
    LicenseService.prototype.licenseValidatedObs = function () {
        return this.licenseValidated.asObservable();
    };
    LicenseService.prototype.validateLicense = function () {
        return this.licenseProxy.validateLicense();
    };
    LicenseService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LicenseService_Factory() { return new LicenseService(i0.ɵɵinject(i1.LicenseProxy)); }, token: LicenseService, providedIn: "root" });
    return LicenseService;
}());
export { LicenseService };
